module.exports = __webpack_public_path__ + "img/header3.0ca31e4e.png";